import { render } from "./TenantIndex.vue?vue&type=template&id=352f964c"
import script from "./TenantIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Tenant/TenantIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "352f964c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('352f964c', __exports__)) {
    api.reload('352f964c', __exports__)
  }
  
  module.hot.accept("./TenantIndex.vue?vue&type=template&id=352f964c", () => {
    api.rerender('352f964c', render)
  })

}


export default __exports__